import { default as React } from 'react';
import { GROUP_BY_FIELD_NAMES } from '../../../common/components/forms/groupByConfigurations/groupByConstants';
import {
    createGroupByOptions,
    keyOrganizationGroupByKeys,
    keyPeopleGroupByKeys,
    projectOwnersGroupByKeys
} from '../../../common/components/forms/groupByConfigurations/groupByUtils';
import { ENTITIES } from '../../../common/constants/customSortFieldConfigs';
import { FORM_WIDGET_COMPONENTS } from '../../../common/form/formConstants';
import { FormContainer } from '../../../common/form/FormContainer';
import FormItem from '../../../common/form/FormItem';
import FormPanel from '../../../common/form/FormPanel';
import FormWidget from '../../../common/form/FormWidget';
import I18n, { useI18n } from '../../../common/i18n/I18n';
import SortConfigFormItems from '../../form/SortConfigFormItems';

export const ProductionDataListConfigFormPanel = () => {
    const t = useI18n();

    const keyProjectOwnersGroupByOptions = createGroupByOptions(projectOwnersGroupByKeys, t);
    const keyPeopleGroupByOptions = createGroupByOptions(keyPeopleGroupByKeys, t);
    const keyOrganizationsGroupByOptions = createGroupByOptions(keyOrganizationGroupByKeys, t);

    return (
        <FormPanel>
            <SortConfigFormItems entity={ENTITIES.workspace} />
            <FormContainer>
                <FormItem>
                    <FormWidget
                        name={GROUP_BY_FIELD_NAMES.projectOwnersGroupBy}
                        label={<I18n token="form.field.group.project.owners.by" />}
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        options={keyProjectOwnersGroupByOptions}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={GROUP_BY_FIELD_NAMES.keyPeopleGroupBy}
                        label={<I18n token="form.field.group.keyPeople.by" />}
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        options={keyPeopleGroupByOptions}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={GROUP_BY_FIELD_NAMES.keyOrganizationsGroupBy}
                        label={<I18n token="form.field.group.orgs.by" />}
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        options={keyOrganizationsGroupByOptions}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
